import React from 'react';
import css from 'styled-jsx/css';
import withI18next from '~/../hocs/_withI18next';
import Container from '~/components/Container';
import themeVariables from '~/shared/themeVariables';

const SEOTextACworks = ({ t, isDownloadPage }) => {
  return (
    <Container
      style={{ marginTop: 64 }}
      contentStyle={{
        padding: 32,
        background: themeVariables.colors.lightBackground,
        borderRadius: 4,
      }}
    >
      <article className="seo-text-acworks">
        {isDownloadPage && (
          <p dangerouslySetInnerHTML={{ __html: t('seo_paragraph_00') }} />
        )}
        <p dangerouslySetInnerHTML={{ __html: t('seo_paragraph_01') }} />
        <p dangerouslySetInnerHTML={{ __html: t('seo_paragraph_02') }} />
        <p dangerouslySetInnerHTML={{ __html: t('seo_paragraph_03') }} />
        <p dangerouslySetInnerHTML={{ __html: t('seo_paragraph_04') }} />
        <p dangerouslySetInnerHTML={{ __html: t('seo_paragraph_05') }} />
        <ul>
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_paragraph_05_item_01') }}
          />
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_paragraph_05_item_02') }}
          />
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_paragraph_05_item_03') }}
          />
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_paragraph_05_item_04') }}
          />
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_paragraph_05_item_05') }}
          />
        </ul>
        <h4 dangerouslySetInnerHTML={{ __html: t('seo_heading_01') }} />
        <ul>
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_heading_01_item_01') }}
          />
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_heading_01_item_02') }}
          />
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_heading_01_item_03') }}
          />
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_heading_01_item_04') }}
          />
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_heading_01_item_05') }}
          />
          <li
            dangerouslySetInnerHTML={{ __html: t('seo_heading_01_item_06') }}
          />
        </ul>
        <h4 dangerouslySetInnerHTML={{ __html: t('seo_heading_02') }} />
        <p
          dangerouslySetInnerHTML={{ __html: t('seo_heading_02_paragraph_01') }}
        />
        <p
          dangerouslySetInnerHTML={{ __html: t('seo_heading_02_paragraph_02') }}
        />
        <ul>
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_02_paragraph_02_item_01'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_02_paragraph_02_item_02'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_02_paragraph_02_item_03'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_02_paragraph_02_item_04'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_02_paragraph_02_item_05'),
            }}
          />
        </ul>
        <h4 dangerouslySetInnerHTML={{ __html: t('seo_heading_03') }} />
        <p
          dangerouslySetInnerHTML={{ __html: t('seo_heading_03_paragraph_01') }}
        />
        <ul>
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_paragraph_01_item_01'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_paragraph_01_item_02'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_paragraph_01_item_03'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_paragraph_01_item_04'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_paragraph_01_item_05'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_paragraph_01_item_06'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_paragraph_01_item_07'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_paragraph_01_item_08'),
            }}
          />
        </ul>
        <h5
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_01'),
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_01_paragraph_01'),
          }}
        />
        <h5
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_02'),
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_02_paragraph_01'),
          }}
        />
        <ul>
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_subheading_02_paragraph_01_item_01'),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t('seo_heading_03_subheading_02_paragraph_01_item_02'),
            }}
          />
        </ul>
        <h5
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_03'),
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_03_paragraph_01'),
          }}
        />
        <h5
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_04'),
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_04_paragraph_01'),
          }}
        />
        <h5
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_05'),
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_05_paragraph_01'),
          }}
        />
        <h5
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_06'),
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_06_paragraph_01'),
          }}
        />
        <h5
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_07'),
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_07_paragraph_01'),
          }}
        />
        <h5
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_08'),
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_08_paragraph_01'),
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t('seo_heading_03_subheading_08_paragraph_02'),
          }}
        />
        <h4 dangerouslySetInnerHTML={{ __html: t('seo_heading_04') }} />
        <p
          dangerouslySetInnerHTML={{ __html: t('seo_heading_04_paragraph_01') }}
        />
        <h4 dangerouslySetInnerHTML={{ __html: t('seo_heading_05') }} />
        <p
          dangerouslySetInnerHTML={{ __html: t('seo_heading_05_paragraph_01') }}
        />
        <p
          dangerouslySetInnerHTML={{ __html: t('seo_heading_05_paragraph_02') }}
        />
      </article>
      <style jsx>{styles}</style>
    </Container>
  );
};

const styles = css`
  .seo-text-acworks {
    width: 100%;
    height: 468px;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  h4 {
    font-size: 18px;
    font-weight: bold;
  }

  h5 {
    font-size: 16px;
    font-weight: bold;
  }
`;

export default withI18next(['component-SEOTextACworks'])(SEOTextACworks);
